import { OverlayTrigger, Tooltip } from "react-bootstrap";

function TextTooltip({ ...props }) {
  return (
    <OverlayTrigger
      placement={props.position}
      delay={{ show: 100, hide: 150 }}
      overlay={
        <Tooltip className="tooltip-font" id="button-tooltip">
          {props.tooltipText}
        </Tooltip>
      }
    >
      {props.children}
    </OverlayTrigger>
  );
}

export default TextTooltip;
